module.exports = __webpack_public_path__ + "static/media/TELabMap.a1bfce1d.png";